export default "__VITE_ASSET__DhJn7d9S__"